<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title">设备管理</span>
          <span class="data_screen_tab">
            <el-input
              v-model="search.query"
              placeholder="mac地址"
              style="width:300px"
              size="small"
              suffix-icon="el-icon-search"
              @change="pageChange(1)"
              clearable
            />
          </span>
          <span class="data_screen_tab">
            <!-- 设备状态  -->
            <el-select
              v-model="search.type"
              clearable
              placeholder="请选择"
              size="small"
              style="width:150px;"
              @change="pageChange(1)"
            >
              <el-option label="所有设备" value />
              <el-option label="A设备" value="1" />
              <el-option label="B设备" value="2" />
            </el-select>
          </span>
          <el-button
            class="data_screen_tab"
            size="small"
            @click="pageChange(1)"
            >查询</el-button>
        </div>
      </div>
      <!-- 具体内容 -->
      <div class="content">
        <div class="content_auto">
          <!-- 表格 -->
          <el-table :data="table_data" style="width: 100%">
            
            <el-table-column prop="deviceMac" label="MAC地址" align="center"></el-table-column>
            <el-table-column prop="deviceType" label="设备类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.deviceType == 1">A</span>
                <span v-if="scope.row.deviceType == 2">B</span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
            <el-table-column prop="nickName" label="用户昵称" align="center">
              <template slot-scope="scope">
                <span v-if="!scope.row.phone" style="color:red">未绑定</span>
                <span v-else>{{scope.row.nickName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="用户手机" align="center">
              <template slot-scope="scope">
                <span v-if="!scope.row.phone" style="color:red">未绑定</span>
                <span v-else>{{scope.row.phone}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="绑定时间" align="center"></el-table-column>
          </el-table>
          <!-- 表格结束 -->
          <!-- 分页 -->
          <div class="page">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="page.total"
              :page-size="page.size"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
 
    return {
      user:null,
      // 搜索
      search: {
        query: null,
        status: "",
        type: ""
      },
      // 分页属性
      page: {
        currPage: 1,
        size: 10,
        total: 100
      },
      // 表格数据
      table_data: [
      ]
      // return 结束
    };
  },
  updated() {},
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.query();
  },
  methods: {
    // 分页改变
    pageChange(res) {
      // console.log("分页", res);
      this.page.currPage = res;
      this.query();
    },
    query(){
      let that = this;
      const url = "/api/web/device/pageDeviceUser";
      that.table_data = [];
      this.$axios
        .post(url, {
          page: this.page.currPage,
          size: this.page.size,
          param:{
            nickName: this.search.query,
            deviceType: this.search.type,
          }

        })
        .then((res) => {
          if (res.data.code == 1000) {
            that.table_data = res.data.data.list;
            that.page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // methods 结束
  }
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  border-radius: 5px;
}

/* 内容盒子 */
.content {
  width: 100%;
  height: calc(100% - 90px);
  /* height: 100%; */
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}
.content_auto {
  height: 100%;
  overflow-y: auto;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}

/* 搜索栏 */
.data_screen {
  height: 90px;
  margin-bottom: 15px;
  padding-top: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: flex-start;
}

.data_screen .data_screen_tab {
  margin-left: 20px;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
}
/* 添加按钮 */
.btn_add {
  position: absolute;
  right: 40px;
}
.open_btn {
  float: left;
  margin-top: 20px;
}
/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
}
/* 添加成员弹窗 */
.dialog_context {
  width: 480px;
}
.btn {
  background-color: #00cb9f;
  border: 0;
}
/* 查询按钮 */
.search_btn{
  margin-left: 20px;
}
/* 批量导入 */
.download_content {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  height: 40px;
  line-height: 38px;
  width: 300px;
  padding-left: 10px;
  padding-bottom: 2px;
  cursor: pointer;
}
.download_content .download_str {
  font-family: PingFang-SC-Medium;
  font-size: 16px;
  color: #bdbdbd;
  letter-spacing: 0;
}
.download_content .download_btn {
  float: right;
  padding-right: 10px;
  line-height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/device/device.vue